<template>
  <Panel size="small">
    <template #header>
      <span data-cy="heading">Offers</span>
    </template>

    <template #content>
      <b-table
        :fields="fields"
        data-cy="table-seller-dashboard-offers"
        :items="offers"
        thead-class="text-nowrap"
        :tbody-tr-class="rowClass"
      >
        <template #cell(spent)="row">
          <div class="text-nowrap">
            {{ `$${row.item.spent.toLocaleString()}` }}
          </div>
        </template>


        <template #cell(callCount)="row">
          <div class="text-nowrap">
            {{ row.item.callCount.toLocaleString() }}
          </div>
        </template>

        <template #cell(convertedCalls)="row">
          <div class="text-nowrap">
            {{ row.item.convertedCalls.toLocaleString() }}
          </div>
        </template>



        <template #cell(conversionPercentage)="row">
          <div class="text-nowrap">
            {{ `${row.item.conversionPercentage.toFixed(2)} %` }}
          </div>
        </template>



        <template #cell(winRatio)="row">
          <div class="text-nowrap">
            {{ `${row.item.winRatio.toFixed(2)} %` }}
          </div>
        </template>

        <template #cell(avgBid)="row">
          <div class="text-nowrap">
            {{ `$${row.item.avgBid.toLocaleString()}` }}
          </div>
        </template>

        <template #cell(totalRevenue)="row">
          <div class="text-nowrap">
            {{ `$${row.item.totalRevenue.toLocaleString()}` }}
          </div>
        </template>

        <template #cell(rpc)="row">
          <div class="text-nowrap">
            {{ `$${Number(row.item.rpc).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
          </div>
        </template>


        <template #cell(status)="row">
          <div class="text-nowrap">
            <b-badge
              v-if="row.item.isApplied"
              variant="success"
              class="px-2 py-1"
            >
              Approved
            </b-badge>
            <b-badge
              v-else
              variant="primary"
              class="px-2 py-1"
            >
              Available
            </b-badge>
          </div>
        </template>
      </b-table>
    </template>
  </Panel>
</template>

<script>

export default {
  name: 'SellerDashboardOffers',

  props: {
    offers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        { key: 'callCount', label: 'Calls' },
        { key: 'convertedCalls', label: 'Billable' },
        { key: 'conversionPercentage', label: 'Conv. %' },
        { key: 'winRatio', label: 'Win Ratio' },
        { key: 'avgBid', label: 'Average Bid' },
        { key: 'totalRevenue', label: 'Revenue' },
        { key: 'rpc', label: 'RPC' },
        {
          key: 'status',
          label: 'Status',
          tdAttr: (value) => {
            return {
              'data-cy': 'status-badge',
              'data-cy-status': value
            }
          }
        },
        { key: 'actions', label: 'Actions' }
      ]
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return ['text-nowrap']
      if (item.isApplied) return ['text-nowrap', 'highlight-applied']
      return ['text-nowrap']
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .highlight-applied {
  background: linear-gradient(90deg, rgba(16, 185, 129, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%) !important;
  border-left: 4px solid #10b981 !important;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  
  &:hover {
    background: linear-gradient(90deg, rgba(16, 185, 129, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%) !important;
  }
  
  td {
      background-color: transparent !important;
  }
}
</style>
